import { useEffect, useState } from 'react';
import { cloneDeep } from 'lodash';
import './index.scss'
import { callAPIForQuery } from '../../../utilities/service';
import { useNavigate } from 'react-router-dom';
import { useCustomContext } from '../../../state/CustomContext';
import { Loader } from '../../common/Loader';
import { ErrorBanner } from '../../common/ErrorBanner';
import { isDropDownSelected } from '../../../utilities/helper';
export const PatientRegister = () => {
    const navigate = useNavigate();
    const context = useCustomContext();
    const { state } = context;
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(false);
    const [vechile, setVechile] = useState<any>([]);
    useEffect(() => {
        loadVechile()
    }, [])
    const [patientInfo, setPatientInfo] = useState<any>({
        "first_name": "",
        "last_name": "",
        "phone_no": "",
        "gender": 0,
        "age": "0",
        "attendee_name": "",
        "attendee_relation": 0,
        "attendee_phone_no": "",
        "chief_complaint": 0,
        "emergency_tag": 0,
        "requested_time": 30,
        "from_location": "",
        "driver": 0,
        "ambulance": 0,
        "readiness_expectation": "",
        "mlc_expectation": "N/A",
        "mlc_spoc":"N/A",
        "mlc_fir_no":"N/A",
        "police_station_name":"N/A"
    })

    const validateAppointment = (data: any) => {
        const errors = [];

        // Validate first_name: should be a non-empty string
        if (typeof data.first_name !== 'string' || data.first_name.toString().trim() === '') {
            errors.push("First name is required and should be a non-empty string.");
        }

        // Validate last_name: should be a non-empty string
        if (typeof data.last_name !== 'string' || data.last_name.toString().trim() === '') {
            errors.push("Last name is required and should be a non-empty string.");
        }

        // Validate phone_no: should be a string of 10 digits
        const phonePattern = /^\d{10}$/;
        if (!phonePattern.test(data.phone_no)) {
            errors.push("Phone number should be a 10-digit string.");
        }

        // Validate gender: should be 'm' or 'f'
        if (!isDropDownSelected('gender', data)) {
            errors.push("Please select the Gender");
        }

        // Validate age: should be a positive integer and between 1 and 150
        if (!data.age || data.age < 1 || data.age > 150) {
            errors.push("Please enter the valid age");
        }

        // Validate attendee_name: should be a non-empty string
        if (typeof data.attendee_name !== 'string' || data.attendee_name.toString().trim() === '') {
            errors.push("Attendee name is required and should be a non-empty string.");
        }

        // Validate attendee_relation: should be an integer

        if (!isDropDownSelected('attendee_relation', data)) {
            errors.push("Please select the attendee relation.");
        }

        // Validate attendee_phone_no: should be a string of 10 digits
        if (!phonePattern.test(data.attendee_phone_no)) {
            errors.push("Attendee phone number should be a 10-digit string.");
        }

        // Validate chief_complaint: should be an integer (valid range depends on use case)

        if (!isDropDownSelected('chief_complaint', data)) {
            errors.push("Chief complaint not selected.");
        }

        // Validate emergency_tag: should be an integer (valid range depends on use case)

        if (!isDropDownSelected('emergency_tag', data)) {
            errors.push("Emergency tag not selected.");
        }

        // Validate requested_time: should be a positive integer
        if (data.requested_time <= 0) {
            errors.push("Requested time should be a valid positive integer.");
        }

        // Validate from_location: should be a non-empty string
        if (typeof data.from_location !== 'string' || data.from_location.toString().trim() === '') {
            errors.push("From location is required and should be a non-empty string.");
        }

        // Validate driver: should be an integer (assuming 1 means assigned and 0 means not assigned)
        if (!isDropDownSelected('driver', data)) {
            errors.push("Please select the driver");
        }

        // Validate ambulance: should be an integer (assuming 1 means assigned and 0 means not assigned)
        if (!isDropDownSelected('ambulance', data)) {
            errors.push("Please select the ambulance");
        }

        // Validate readiness_expectation: should be a non-empty string
        if (typeof data.readiness_expectation !== 'string' || data.readiness_expectation.toString().trim() === '') {
            errors.push("Readiness expectation should be a non-empty string.");
        }

        // Validate mlc_expectation: should be a non-empty string
        if (typeof data.mlc_expectation !== 'string' || data.mlc_expectation.toString().trim() === '') {
            errors.push("MLC expectation should be a non-empty string.");
        }

        // Return errors or success message
        if (errors.length > 0) {
            return { valid: false, errors: errors };
        } else {
            return { valid: true, message: "Validation successful!" };
        }
    }

    const loadVechile = async () => {
        const procedure = 'get_ambulance_vechile';
        setLoading(true)
        const result = await callAPIForQuery({ input: '{}', type: procedure }, 'post')
        setLoading(false)
        if (!result.error) {

            setVechile(result[0])
        } else {
            setError(true)
        }
    }
    const updatePatientInfo = (key: string, value: string) => {
        const patientInfoCopy: any = cloneDeep(patientInfo);
        patientInfoCopy[key] = value;
        setPatientInfo(patientInfoCopy);
    }
    const savePatientInfo = async () => {
        const validationResult = validateAppointment(patientInfo);
        if (validationResult.valid) {
            let xmlString = '<profile>'
            Object.keys(patientInfo).forEach(element => {
                xmlString += `<${element}>${patientInfo[element]}</${element}>`
            });
            xmlString += `<created_by>${state.user_id}</created_by>`
            xmlString += `</profile>`
            setLoading(true)
            const result = await callAPIForQuery({ input: xmlString, type: 'insert_appointment_from_xml' }, 'post')
            setLoading(false)
            if (!result.error) {
                alert(`Successfully saved the appointment. The appointmentid is ${result[0][0].id}`);
                navigate('/patient-view')
            } else {
                alert("Some error occurred. Please contact your administrator")
            }
        } else {
            alert(validationResult.errors?.[0])
        }
    }
    const component = <div className="row">
        <div className="col-lg-2">
            <div className="form-option">
                <div className="field-title required">First name</div>
                <input className="form-control" value={patientInfo.first_name || ''} onChange={(event: any) => {
                    updatePatientInfo("first_name", event.target.value)
                }} />
            </div>
        </div>
        <div className="col-lg-2">
            <div className="form-option">
                <div className="field-title required">Last name</div>
                <input className="form-control" value={patientInfo.last_name || ''} onChange={(event: any) => {
                    updatePatientInfo("last_name", event.target.value)
                }} />
            </div>
        </div>
        <div className="col-lg-2">
            <div className="form-option">
                <div className="field-title required">Phone No</div>
                <input className="form-control" value={patientInfo.phone_no || ''} onChange={(event: any) => {
                    updatePatientInfo("phone_no", event.target.value)
                }} />
            </div>
        </div>
        <div className="col-lg-2">
            <div className="form-option">
                <div className="field-title required">Gender</div>
                <select className='form-control' value={patientInfo.gender || '0'} onChange={(event: any) => {
                    updatePatientInfo("gender", event.target.value)
                }}>
                    <option value={"0"}>--Select--</option>
                    <option value={'m'}>Male</option>
                    <option value={'f'}>Female</option>
                </select>
            </div>
        </div>
        <div className="col-lg-2">
            <div className="form-option">
                <div className="field-title required">Age</div>
                <input className="form-control" value={patientInfo.age || ''} onChange={(event: any) => {
                    updatePatientInfo("age", event.target.value)
                }} />
            </div>
        </div>
        <div className="col-lg-2">
            <div className="form-option">
                <div className="field-title required">Attendee name</div>
                <input className="form-control" value={patientInfo.attendee_name || ''} onChange={(event: any) => {
                    updatePatientInfo("attendee_name", event.target.value)
                }} />
            </div>
        </div>
        <div className="col-lg-2">
            <div className="form-option">
                <div className="field-title required">Attendee relation</div>
                <select className='form-control' value={patientInfo.attendee_relation || '0'} onChange={(event: any) => {
                    updatePatientInfo("attendee_relation", event.target.value)
                }}>
                    <option value={"0"}>--Select--</option>
                    <option value={'1'}>Father</option>
                    <option value={'2'}>Mother</option>
                    <option value={'3'}>Other</option>
                </select>
            </div>
        </div>
        <div className="col-lg-2">
            <div className="form-option">
                <div className="field-title required">Attendee phone no</div>
                <input className="form-control" value={patientInfo.attendee_phone_no || ''} onChange={(event: any) => {
                    updatePatientInfo("attendee_phone_no", event.target.value)
                }} />
            </div>
        </div>
        <div className="col-lg-2">
            <div className="form-option">
                <div className="field-title required">Chief Complaint</div>
                <select className='form-control' value={patientInfo.chief_complaint || '0'} onChange={(event: any) => {
                    updatePatientInfo("chief_complaint", event.target.value)
                }}>
                    <option value={"0"}>--Select--</option>
                    <option value={'1'}>Snowmed</option>
                    <option value={'2'}>CT</option>
                    <option value={'3'}>Integration</option>
                </select>
            </div>
        </div>
        <div className="col-lg-2">
            <div className="form-option">
                <div className="field-title required">Emergency tag</div>
                <select className='form-control' value={patientInfo.emergency_tag || '0'} onChange={(event: any) => {
                    updatePatientInfo("emergency_tag", event.target.value)
                }}>
                    <option value={"0"}>--Select--</option>
                    <option value={'1'}>Red</option>
                    <option value={'2'}>Amber</option>
                </select>
            </div>
        </div>
        <div className="col-lg-2">
            <div className="form-option">
                <div className="field-title required">Requested Time(in minutes)</div>
                <input className="form-control" value={patientInfo.requested_time || '10'} onChange={(event: any) => {
                    updatePatientInfo("requested_time", event.target.value)
                }} />
            </div>
        </div>
        <div className="col-lg-2">
            <div className="form-option">
                <div className="field-title required">From Location</div>
                <input className="form-control" value={patientInfo.from_location || ''} onChange={(event: any) => {
                    updatePatientInfo("from_location", event.target.value)
                }} />
            </div>
        </div>
        <div className="col-lg-2">
            <div className="form-option">
                <div className="field-title required">Driver</div>
                <select className='form-control' value={patientInfo.driver || '0'} onChange={(event: any) => {
                    updatePatientInfo("driver", event.target.value)
                }} >
                    <option value={"0"}>--Select--</option>
                    <option value={'1'}>Driver 1</option>
                    <option value={'2'}>Driver 2</option>
                </select>
            </div>
        </div>
        <div className="col-lg-2">
            <div className="form-option">
                <div className="field-title required">Ambulance</div>
                <select className='form-control' value={patientInfo.ambulance || '0'} onChange={(event: any) => {
                    updatePatientInfo("ambulance", event.target.value)
                }}>
                    <option value={"0"}>--Select--</option>
                    {vechile.map((opt: any) => {
                        return <option key={opt.id} value={opt.id}>{opt.name}</option>
                    })}
                </select>
            </div>
        </div>
        <div className="col-lg-2">
            <div className="form-option">
                <div className="field-title required">Readiness Expectation</div>
                <input className="form-control" value={patientInfo.readiness_expectation || ''} onChange={(event: any) => {
                    updatePatientInfo("readiness_expectation", event.target.value)
                }} />
            </div>
        </div>
       {/*  <div className="col-lg-2">
            <div className="form-option">
                <div className="field-title required">MLC Expectation</div>
                <input className="form-control" value={patientInfo.mlc_expectation || ''} onChange={(event: any) => {
                    updatePatientInfo("mlc_expectation", event.target.value)
                }} />
            </div>
        </div>
        <div className="col-lg-2">
            <div className="form-option">
                <div className="field-title required">MLC SPOC</div>
                <input className="form-control" value={patientInfo.mlc_spoc || ''} onChange={(event: any) => {
                    updatePatientInfo("mlc_spoc", event.target.value)
                }} />
            </div>
        </div>
        <div className="col-lg-2">
            <div className="form-option">
                <div className="field-title required">MLC FIR No</div>
                <input className="form-control" value={patientInfo.mlc_fir_no || ''} onChange={(event: any) => {
                    updatePatientInfo("mlc_fir_no", event.target.value)
                }} />
            </div>
        </div>
        <div className="col-lg-2">
            <div className="form-option">
                <div className="field-title required">Police Station Name</div>
                <input className="form-control" value={patientInfo.police_station_name || ''} onChange={(event: any) => {
                    updatePatientInfo("police_station_name", event.target.value)
                }} />
            </div>
        </div> */}
    </div>;
    if (error) {
        return <ErrorBanner />
    }
    return <div>
        <div className="module-title">Patient Registration</div>
        {loading ? null : component}
        {loading && <Loader />}
        {!loading && (<div className='action-set'>
            <input type="button" value="Save" onClick={savePatientInfo} />
            <input type="button" value="Reset" />
        </div>)}
    </div>
}